import React, { useState, lazy, Suspense } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './TabBar.css';

const Grid = lazy(() => import('./Grid'));
const AboutContent = lazy(() => import('./AboutContent'));

const Tabs = {
  WORKS: 'WORKS',
  ABOUT: 'ABOUT',
};

const TabBar = () => {
  const [activeTab, setActiveTab] = useState(Tabs.WORKS);

  return (
    <>
      <div className="sticky-bar">
        <motion.div
          className="sticky-bar-inner tab-bar"
          initial={{ opacity: 0, x: -80, filter: 'blur(10px)' }}
          animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.3 }}
        >
          <button
            type="button"
            className={activeTab === Tabs.WORKS ? 'tab tab--active' : 'tab'}
            onClick={() => setActiveTab(Tabs.WORKS)}
          >
            Works
          </button>
          <button
            type="button"
            className={activeTab === Tabs.ABOUT ? 'tab tab--active' : 'tab'}
            onClick={() => setActiveTab(Tabs.ABOUT)}
          >
            About
          </button>
        </motion.div>
      </div>

      <div className="page-content tab-content">
        <Suspense fallback={null}>
          <AnimatePresence initial={false} mode="wait">
            {activeTab === Tabs.WORKS && (
              <motion.div
                key="works"
                className="animated-content"
                initial={{ opacity: 0, y: -80, scale: 0.95, filter: 'blur(40px)' }}
                animate={{ opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' }}
                exit={{ opacity: 0, y: 80, scale: 0.95, filter: 'blur(40px)' }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
              >
                <Grid />
              </motion.div>
            )}
            {activeTab === Tabs.ABOUT && (
              <motion.div
                key="about"
                className="animated-content"
                initial={{ opacity: 0, y: -80, scale: 0.95, filter: 'blur(40px)' }}
                animate={{ opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' }}
                exit={{ opacity: 0, y: 80, scale: 0.95, filter: 'blur(40px)' }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
              >
                <AboutContent />
              </motion.div>
            )}
          </AnimatePresence>
        </Suspense>
      </div>
    </>
  );
};

export default TabBar;
